export const TimeListArr = (timeData) => {
  let returnArr = new Array();
  let hourCnt = 0;

  for (let i = 0; i < timeData.length; i++) {
    if (i == 0) {
      returnArr.push({
        license: timeData[i].license,
        appHour: timeData[i].appHour,
        appMin: [timeData[i].appMin],
      });
    } else {
      if (timeData[i].appHour === timeData[i - 1].appHour) {
        returnArr[hourCnt].appMin.push(timeData[i].appMin);
      } else {
        returnArr.push({
          license: timeData[i].license,
          appHour: timeData[i].appHour,
          appMin: [timeData[i].appMin],
        });

        hourCnt = hourCnt + 1;
      }
    }
  }
  return returnArr;
};

export const TestTimeList = [
  {
    license: "미지정",
    appHour: "16",
    appMin: "50",
  },
  {
    license: "미지정",
    appHour: "16",
    appMin: "55",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "05",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "10",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "15",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "20",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "25",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "30",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "35",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "40",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "45",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "50",
  },
  {
    license: "미지정",
    appHour: "17",
    appMin: "55",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "00",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "05",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "10",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "15",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "20",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "30",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "35",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "40",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "45",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "50",
  },
  {
    license: "미지정",
    appHour: "18",
    appMin: "55",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "00",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "05",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "10",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "15",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "20",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "25",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "30",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "35",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "40",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "45",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "50",
  },
  {
    license: "미지정",
    appHour: "19",
    appMin: "55",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "00",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "05",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "10",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "20",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "25",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "30",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "35",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "40",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "45",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "50",
  },
  {
    license: "미지정",
    appHour: "20",
    appMin: "55",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "00",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "05",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "10",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "20",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "25",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "30",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "35",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "40",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "45",
  },
  {
    license: "미지정",
    appHour: "21",
    appMin: "55",
  },
];

/*
  {
    license: "김의사",
    time: [
      appHour: "16",
      appMin: [minArr],
    ]

  }
*/
